import { useParams } from 'react-router-dom';

export function Optional<T = unknown>(Constructor: Constructor<T>): Constructor<T | undefined> {
  return (value) => (value ? Constructor(value) : undefined);
}

type Constructor<T = unknown> = (value: string | undefined) => T;

type Constructors<K extends string = string, T extends Constructor = Constructor> = {
  [P in K]: T;
};

export default function useTypedParams<
  TConstructors extends Constructors = Constructors,
  Params = { [K in keyof TConstructors]: ReturnType<TConstructors[K]> }
>(constructors: TConstructors) {
  const params = useParams();

  return Object.fromEntries(
    Object.entries(constructors).map(([key, predicate]) => [key, predicate(params[key])])
  ) as unknown as Params;
}
